/**
 * Centralised TanStack Query keys for the dividends resource.
 *
 * A posted declaration moves three things at once — the register's accrued
 * positions, the journal and the account balances the tie-out reads — and a
 * settings change moves every rate-derived figure on the screen. Keeping the keys
 * here is what lets both invalidations stay one-liners.
 */
export const DividendQueryKeys = {
    all: ['dividends'] as const,
    shareholders: (asOf: string) =>
        [...DividendQueryKeys.all, 'shareholders', asOf] as const,
    declarations: () => [...DividendQueryKeys.all, 'declarations'] as const,
    /** A declaration is addressed by the id of the entry it created. */
    declaration: (journalEntryId: string) =>
        [...DividendQueryKeys.all, 'declaration', journalEntryId] as const,
    /**
     * The calculator is a query rather than a mutation: it is a pure read that
     * refetches as the user types, and keying it on the inputs means an identical
     * question is answered from cache.
     */
    quote: (direction: string, amount: string, asOf: string) =>
        [...DividendQueryKeys.all, 'quote', direction, amount, asOf] as const,
};
